import { render, staticRenderFns } from "./pro_i_page_dual.vue?vue&type=template&id=0c60d872&scoped=true"
import script from "./pro_i_page_dual.vue?vue&type=script&lang=js"
export * from "./pro_i_page_dual.vue?vue&type=script&lang=js"
import style0 from "./pro_i_page_dual.vue?vue&type=style&index=0&id=0c60d872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c60d872",
  null
  
)

export default component.exports